import { css } from '@emotion/react';
import { getFullName } from '@frontend/name';
import { useContactPanelShallowStore } from '@frontend/shared';
import { Avatar, Text } from '@frontend/design-system';
import type { MockActivityData } from './use-mock-schedule-activity';

export const PatientCellRenderer = ({ row }: { row: MockActivityData }) => {
  const { setPersonId, setSelectedTab } = useContactPanelShallowStore('setPersonId', 'setSelectedTab');

  if (!row?.patient?.firstName && !row?.patient?.lastName) {
    return <Text size='medium'>-</Text>;
  }

  const handleAvatarClick = () => {
    const personId = row.patient.patientId;
    setPersonId(personId, true);
    setSelectedTab('overview-tab');
  };

  return (
    <div css={containerstyles}>
      {/* TODO: Use patient image when API is ready */}
      <Avatar name={getFullName(row.patient)} size='small' onClick={handleAvatarClick} />
      <span css={patientNameStyles}>
        <Text size='medium' weight='bold'>
          {row.patient.firstName}
        </Text>
        <Text size='medium'>{row.patient.lastName}</Text>
      </span>
    </div>
  );
};

const containerstyles = css`
  display: flex;
  align-items: center;
  gap: var(--fabric-space-gap-xs);
`;

const patientNameStyles = css`
  display: flex;
  align-items: center;
  gap: var(--fabric-space-gap-xxs);
`;
